import { render, staticRenderFns } from "./WeaPricter.vue?vue&type=template&id=45fbcfec&scoped=true"
import script from "./WeaPricter.vue?vue&type=script&lang=js"
export * from "./WeaPricter.vue?vue&type=script&lang=js"
import style0 from "./WeaPricter.vue?vue&type=style&index=0&id=45fbcfec&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fbcfec",
  null
  
)

export default component.exports